export function api2() {
     return window.app.api2;
}
